import React from 'react';
import ReactDOM from 'react-dom';

import { Router, Route, Switch } from "react-router-dom";

import history from './history';
// import { useRouterHistory } from 'react-router';
// import { createBrowserHistory } from 'react-router/node_modules/history/lib/createBrowserHistory';


import App from './App';
import Dashboard from './components/Dashboard';
import SignIn from './components/SignIn';
import Settings from './components/admin/Settings';
import Company from './components/admin/Company';
import Structure from './components/admin/views/Structure';
import CompanyRegistration from './components/admin/CompanyRegistration';

import * as serviceWorker from './serviceWorker';

import { GuardProvider, GuardedRoute } from 'react-router-guards';

const requireLogin = (to, from, next) => {

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  if(token && userId){
    next();
  }

  next.redirect('login');
};

// const history = useRouterHistory(createBrowserHistory)({
//      basename: '/base-path'
// })
         // <Redirect from="/" to="/login" />

ReactDOM.render(
  <Router history={history} basename={process.env.REACT_APP_PREFIX_DIR}>
   <div>
     <GuardProvider guards={[requireLogin]}>
       <Switch>
        <GuardedRoute path={process.env.REACT_APP_PREFIX_DIR+"/dashboard"} exact component={Dashboard} />
        <GuardedRoute path={process.env.REACT_APP_PREFIX_DIR+"/settings"} exact component={Settings} />
        <GuardedRoute path={process.env.REACT_APP_PREFIX_DIR+"/companies"} exact component={Company} />
        <GuardedRoute path={process.env.REACT_APP_PREFIX_DIR+"/structure"} exact component={Structure} />
        <GuardedRoute path={process.env.REACT_APP_PREFIX_DIR+"/companies/register"} exact component={CompanyRegistration} />
        <Route path={process.env.REACT_APP_PREFIX_DIR+"/login"} component={SignIn} />
        <Route exact path={process.env.REACT_APP_PREFIX_DIR} component={App} />
       </Switch>
     </GuardProvider>
   </div>
  </Router>,
  document.getElementById('root')
);

serviceWorker.unregister();
